import { Reveal, Label } from "@/components/site/Motion";
import { PageHero, CTASection } from "@/components/site/Sections";
import { VALUES } from "@/data/content";
import { useSettings } from "@/hooks/useSettings";
import { Star } from "lucide-react";

export default function About() {
  const s = useSettings();
  return (
    <div data-testid="about-page">
      <PageHero
        eyebrow="About United Youngs India"
        title="Turning visions into reality since day one."
        subtitle="A Lucknow-born construction and interior design house built on quality, precision and an unwavering commitment to the families and businesses we serve."
        image="https://images.unsplash.com/photo-1577199001468-44c049e7603f?crop=entropy&cs=srgb&fm=jpg&q=85"
      />

      <section className="mx-auto max-w-7xl px-5 lg:px-8 py-24 lg:py-32">
        <div className="grid gap-14 md:grid-cols-12 items-center">
          <div className="md:col-span-6">
            <div className="relative overflow-hidden rounded-sm">
              <img
                src="https://images.unsplash.com/photo-1632201147654-f6f54427e538?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="UYI team on an Indian construction site"
                className="w-full h-[520px] object-cover"
              />
            </div>
          </div>
          <div className="md:col-span-6">
            <Label>Our story</Label>
            <Reveal>
              <h2 className="mt-5 font-display text-3xl md:text-4xl font-light tracking-tight text-navy leading-tight">
                Built on strong foundations — literally and figuratively.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-navy/60 leading-relaxed">{s.about}</p>
              <p className="mt-4 text-navy/60 leading-relaxed">
                From residential villas to commercial landmarks, complete interiors
                to bespoke furniture, we bring a single standard of craftsmanship to
                every project across Lucknow and Uttar Pradesh.
              </p>
            </Reveal>
            <div className="mt-8 flex items-center gap-3 text-gold">
              <Star className="h-5 w-5 fill-gold" />
              <span className="text-navy/70">{s.rating} rating · {s.years_experience} years of experience</span>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-navy text-white grain relative overflow-hidden">
        <div className="relative z-10 mx-auto max-w-7xl px-5 lg:px-8 py-24">
          <Label>What we stand for</Label>
          <div className="mt-12 grid gap-8 md:grid-cols-3">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} delay={i * 0.08}>
                <div className="border-t border-white/15 pt-6">
                  <h3 className="font-display text-2xl text-gold">{v.title}</h3>
                  <p className="mt-3 text-white/55 leading-relaxed">{v.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
